module.exports = __webpack_public_path__ + "img/bag.99a49e53.png";